<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <div v-if="!this.live">
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Cattle Drive Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE</div>

        <div class="headline text-xs-center">
          <p>June 14 - 18, 2027</p>
        </div>

        <div class="headline text-xs-center">
          <p>Cattle Drive Registration starts Sept 1st 2027 at 10AM PST</p>
        </div>
      </v-card>
        </div>
        <div v-else>
      <v-card v-if="!good" class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Cattle Drive Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div v-if="this.count < this.totalRiders" class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE APPLICATION</div>
        <div v-else class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE WAIT LIST</div>

        <div class="headline text-xs-center">
          <p>June 14 - 18, 2027</p>
        </div>

        <div class="headline text-xs-center">
          <p>Cattle Drive Registration starts Sept 1st 2027</p>
        </div>
      </v-card>
      <v-card v-else class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Cattle Drive Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div v-if="this.count < this.totalRiders" class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE APPLICATION</div>
        <div v-else class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE WAIT LIST</div>

        <div class="headline text-xs-center">
          <p>June 14 - 18, 2027</p>
        </div>

        <div v-if="saved">
          <div v-if="this.count < this.totalRiders" class="subheading mx-4">
            <h2>Congratulations!</h2>
            You have secured a spot on the 2027 Reno Rodeo Cattle Drive. Please keep an eye out for email confirmation and more information to
            come. Please add renorodeocattledrive@gmail.com to your address list.
          </div>
          <div v-else class="subheading mx-4">
            <h2>Thank you!</h2>
            You are currently added to the <i>Waitlist</i> for the 2027 Reno Rodeo Cattle Drive. Please keep an eye out for future email updates regarding your waitlist status. Please add renorodeocattledrive@gmail.com to your address list.
          </div>
        </div>
        <div v-else>
        <div class="headline text-xs-center">
          <p>Please Print Clearly and Accurately</p>
        </div>

        <div class="headline text-xs-center mt-4">
          <span class="red--text">All information is required.</span>
        </div>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Rider Name"
                    ref="focusName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md6>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md6>
                      <v-text-field
                        v-model="editedItem.state"
                        label="State/Province"
                        :rules="[v => !!v || 'State/Province is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Postal Code"
                        :rules="[v => !!v || 'Postal Code is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.country"
                        label="Country"
                        :rules="[v => !!v || 'Country is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.primaryPhone"
                    label="Primary Phone"
                    prepend-icon="stay_current_portrait"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.secondaryPhone"
                    label="Secondary Phone"
                    prepend-icon="phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Occupation"
                    v-model="editedItem.occupation"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="editedItem.age"
                    label="Age"
                    mask="###"
                    :rules="[v => !!v || 'Age is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="editedItem.weight"
                    label="Weight (Max 240lbs.)"
                    mask="###"
                    :rules="[v => !!v || 'Weight is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-text-field
                    v-model="editedItem.height"
                    label="Height"
                    :rules="[v => !!v || 'Height is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-select
                    v-model="editedItem.sex"
                    :items="sexs"
                    label="Sex"
                    :rules="[v => !!v || 'You must choose your sex!']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Name of Spouse/Significant Other"
                    v-model="editedItem.spouse"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">EMERGENCY CONTACT</span>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field
                    v-model="editedItem.contactName"
                    @keyup.enter="save"
                    label="Contact Name"
                    :rules="[v => !!v || 'Contact Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field
                    v-model="editedItem.contactRelation"
                    @keyup.enter="save"
                    label="Contact Relationship"
                    :rules="[v => !!v || 'Contact Relationship is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="editedItem.contactPhone"
                    @keyup.enter="save"
                    label="Contact Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Contact Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex>
                <v-textarea
                  v-model="editedItem.medicalConditions"
                  label="If you have any medical conditions (heart condition, diabetes, etc.) that we should be aware of, please explain"
                  prepend-icon="mdi-medical-bag"
                  :rules="[v => !!v || 'Medical conditions is required']"
                  required
                ></v-textarea>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">Important Riding Ability Information</span>
                </v-flex>
                <v-flex class="subheading" xs12>
                  The cattle drive is a very physically demanding experience. You <b>MUST</b> be physically fit, should be comfortable with the walk and trot, navigating varied terrain and riding outside an arena.
                  This trip is rated as Intermediate in terms of required riding skill. Participants should possess the necessary experience to confidently and safely participate in a ride of this level.
                  The cattle drive will involve navigating hills, dry creeks, rocky ground, hillsides, roads and pavement, in addition to encountering unexpected situations. You will be riding out in the
                  open, with no mounting blocks available, <b>therefore you must be able to mount an average size horse from the ground without assistance.</b> Unless you ride regularly for multiple hours at a
                  time, you <b>WILL</b> hurt and be sore, guaranteed!
                </v-flex>
                <v-flex class="subheading" xs12>
                  This cattle drive takes place in the high desert where conditions and terrain will vary greatly and is physically demanding. Before signing up for this experience, you should ask yourself
                  the following questions: Please check the box that you have read and agree to each question.
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="editedItem.stairs"
                    label="Can I climb a few flights of stairs without shortness of breath?"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    required
                  ></v-checkbox><br />
                  <v-checkbox
                    v-model="editedItem.lift"
                    label="Can I lift 40-50 pounds?"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    required
                  ></v-checkbox><br />
                  <v-checkbox
                    v-model="editedItem.mount"
                    label="Can I mount and dismount a horse without physical assistance? "
                    :rules="[v => !!v || 'You must agree to continue!']"
                    required
                  ></v-checkbox><br />
                  <v-checkbox
                    v-model="editedItem.walk"
                    label="Can I walk 1-2 miles comfortably?"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    required
                  ></v-checkbox>
                </v-flex>
                <v-flex class="subheading" xs12>
                  We <b>DO NOT</b> recommend this cattle drive for people over the age of 75, heavy smokers, the obese, people with heart or lung conditions, major medical conditions, or anyone who may have trouble
                  breathing at over 6,000 feet in elevation. Honesty about your physical fitness and riding ability is essential for a positive experience.Carefully review the requirements and assess your
                  skill level to determine if this vacation is a good fit.
                </v-flex>
                <v-flex class="subheading" xs12>
                  <b>Important information about physical fitness and riding experience:</b>
                </v-flex>
                <v-flex class="subheading" xs12>
                  A riding assessment can take place at any time during the cattle drive. If at any point you are determined unfit to ride by your Wrangler or Trail Boss, you will not be able to ride the remainder
                  of the cattle drive and you will be riding in a wagon from camp to camp each day. This is to ensure your safety first and foremost, as well as, the safety of fellow participants, the cattle drive
                  crew, the horses and our livestock.
                </v-flex>
                <v-flex class="subheading" xs12 md8>
                  <v-text-field
                    v-model="editedItem.sig1"
                    label="Signature"
                    :rules="[v => !!v || 'Signature is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="subheading" xs12 md4>
                  <v-text-field
                    v-model="editedItem.date1"
                    label="Date"
                    :rules="[v => !!v || 'Date is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">HORSE RIDING EXPERIENCE</span>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span ><i>Please select the Level that most accurately describes your riding ability</i></span>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                    v-model="editedItem.experience"
                    :rules="[v => !!v || 'Experience is required']"
                    required
                  >
                    <v-radio label="Beginner/Novice - Level 1: Rider has minimal to no riding experience, may be learning to walk, but is not yet comfortable at other gaits. Rider can walk the horse with guidance, beginning to learn the trot, but may not be comfortable or balanced at this gait. Rider is not confident or in control at a lope. They are able to mount safely and to control the horse at a walk." value="Beginner"></v-radio>
                    <v-radio label=" Intermediate - Level 2: Rider can independently control the horse at a walk and rising trot, is learning to lope and may be able to do so with some guidance. Rider is beginning to understand and use basic riding aids: reins, legs, and seat to communicate with the horse. The rider is able to mount and dismount their horse unassisted, and is comfortable riding out in open countryside." value="Intermediate"></v-radio>
                    <v-radio label="Experienced - Level 3: Rider can comfortably and confidently control the horse at all three gaits (walk, rising trot, lope), and can ride in various terrains and conditions (e.g. open fields, trails). Rider has a good understanding of riding aides and can use them effectively. The rider rides regularly, has a good seat and can change direction of their horse at any pace and in any circumstance as needed." value="Experienced"></v-radio>
                    <v-radio label="Advanced - Level 4: Rider has a confident and independent seat at all 4 gaits (walk, rising trot, lope and gallop) and can control the horse on varied terrain. Rider is comfortable riding horses with more energy and reactivity. Rider can perform more advanced riding maneuvers, such as lateral movements, leg yields and may compete in horse shows or other equestrian events. The advanced rider rides regularly, has good physical fitness, and has soft hands." value="Advanced"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">GUEST INFORMATION</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.otherRiders"
                    label="1. If you are joining us with a friend or a group and wish to be on the same team, please list the name(s) below:"
                    prepend-icon="mdi-account-group"
                ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.past"
                    label="2. Have you been a past participant on the Cattle Drive? If so, what year(s)?"
                    prepend-icon="mdi-account-group"
                ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.whyGo"
                    label="3. What prompted you to participate in the Reno Rodeo Cattle Drive? Bucket list? To celebrate a birthday or anniversary? To accompany a friend or relative? Please tell us about it in the area provided below:"
                    prepend-icon="notes"
                    :rules="[v => !!v || 'What prompted you to participate is required']"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs6 md3>
                  <v-select
                    v-model="editedItem.shirt"
                    :items="shirts"
                    label="Shirt Size"
                    :rules="[v => !!v || 'You must choose your shirt!']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">CREDIT CARD INFORMATION</span>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12>
                  <v-text-field
                    v-model="editedItem.number"
                    label="Credit Card Number"
                    :rules="[v => !!v || 'Credit Card Number is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12>
                  <v-text-field
                    v-model="editedItem.cardName"
                    label="Name on Card"
                    :rules="[v => !!v || 'Name on Card is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs6 md3>
                  <v-text-field
                    v-model="editedItem.expire"
                    label="Expires"
                    mask="##/##"
                    return-masked-value
                    :rules="[v => !!v || 'Expires is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.cvv"
                    label="CVV"
                    mask="####"
                    :rules="[v => !!v || 'CVV is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.amount"
                    label="Amount"
                    :rules="[v => !!v || 'Amount is required']"
                    mask="####.##"
                    prefix="$"
                    readonly
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

        <div class="title text-xs-center mb-4">
          <span v-if="this.count < this.totalRiders" class="blue--text">REGISTRATION INFORMATION</span>
          <span v-else class="blue--text">WAIT LIST INFORMATION</span>
        </div>

        <div class="subheading mx-4">
          <div v-if="this.count < this.totalRiders">
            <p>
              The cost for the 2027 Reno Rodeo Cattle Drive is $3400 per person. This price includes a 2027 Reno Rodeo Cattle Drive belt buckle (valued at $250).
            </p>

            <p>
              *Pricing is all inclusive.
            </p>
            <p><strong>Refund/Cancellation Policy:</strong><br />
              <span>We are unable to roll over funds for the following year. If you are unable to attend the drive, you have until March 15th of
                the same year you are signed up for to request a refund. The refund request must be in writing. We will refund your fee minus a $1,000 processing
                fee if request is made before the deadline. A doctor's note will not waive the processing fee. We will not process refunds after March 15th and
                your full payment will be forfeited if you do not attend.</span>
            </p>
          </div>

          <p><strong>Rules of the Cattle Drive:</strong><br />
            <ul>
              <li>No guest will be allowed to bring his or her horse on the cattle drive. <strong>NO EXCEPTIONS.</strong></li>
              <li>All riders must be <strong>18</strong> years of age.</li>
              <li>No dogs or other pets are allowed.</li>
              <li>No alcoholic beverages will be permitted while riding. The bar remains closed until every guest is safely back in camp and no other riding is
                planned for the day.</li>
              <li>No firearms allowed. No exceptions, even CCW carriers.</li>
              <li>Willful disregard for the rules or acts of disorderliness will not be tolerated. In the interest of the safety of the guests and to ensure a
                pleasurable experience for everyone, the Trail Boss or Cow Boss may remove a guest at any time from the Drive who demonstrates these characteristics.
                Any mistreatment of persons, animals or public drunkenness will be cause for removal.
                <v-checkbox
                  v-model="editedItem.disorder"
                  label="Agree"
                  :rules="[v => !!v || 'You must agree to continue!']"
                  required
                ></v-checkbox>
              </li>
              <li>You understand and agree to the <b>Riding Ability information</b> stated above and that you may be removed and/or placed in a wagon at any time during
                the ride if you are determined to be unfit for riding due to lack of physical ability or a medical condition that prevents you from participating.
                <v-checkbox
                  v-model="editedItem.ability"
                  label="Agree"
                  :rules="[v => !!v || 'You must agree to continue!']"
                  required
                ></v-checkbox>
              </li>
            </ul>
          </p>
            <v-container>
                <v-flex class="subheading" xs12 md8>
                  <v-text-field
                    v-model="editedItem.sig2"
                    label="Signature"
                    :rules="[v => !!v || 'Signature is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="subheading" xs12 md4>
                  <v-text-field
                    v-model="editedItem.date2"
                    label="Date"
                    :rules="[v => !!v || 'Date is required']"
                    required
                  ></v-text-field>
                </v-flex>
              </v-container>
        </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="checkbox"
            label="I have read and agree to the Registration Information, and acknowledge the Fee, Refund and Cancellation policies!"
            :rules="[v => !!v || 'You must agree to continue!']"
            required
          ></v-checkbox>
          <v-btn v-if="this.count < this.totalRiders" color="primary" @click="save">Submit Application</v-btn>
          <v-btn v-else @click="save">Submit to Wait List</v-btn>
        </v-card-actions>
      </v-form>
        </div>
      </v-card>
      </div>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      count: 0,
      good: false,
      live: true,
      saved: false,
      totalRiders: 30,
      currentYear: 0,
      checkbox: false,
      sexs: ['Male', 'Female'],
      shirts: ['Women - S', 'Women - M', 'Women - L', 'Women - XL', 'Women - XXL', 'Men - S', 'Men - M', 'Men - L', 'Men - XL', 'Men - XXL', 'Men - XXXL'],
      editedItem: {},
      amount: '3400.00',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.good = true
    this.editedItem.amount = this.amount
    this.getDate()
    this.getCount()
  },

  methods: {
    getDate () {
      const hour = moment().format('H')
      const utc = moment.utc().format('H')
      const date = moment().format('YYYY-MM-DD')
      const startDate = moment().format('2026-09-01')

      console.log('hour', hour)
      console.log('utc', utc)

      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }

      if ((date === startDate && utc >= 17) || date > startDate) {
        this.live = true
      }
    },

    async getCount () {
      console.log(this.currentYear)
      try {
        const response = await Api().get('get_cdcount/' + this.currentYear)
        this.count = response.data.length
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.getCount()

        console.log(this.count, this.totalRiders)
        if (this.count >= this.totalRiders) {
          this.editedItem.status = 'Wait List'
        }

        console.log(this.editedItem)

        if (this.$refs.form.validate()) {
          if (this.count >= this.totalRiders) {
            const response = await Api().post('extern_cattledrive', this.editedItem)
            console.log(response.data)

            this.snackbar.message = 'Congratulation, you have been added to the Wait List'
          } else {
            const response = await Api().post('extern_cd_payment', this.editedItem)
            console.log(response.data)

            this.snackbar.message = 'Congratulation, your registration has been submitted!'
          }

          this.saved = true
          window.scrollTo(0, 0)

          // this.snackbar.color = 'success'
          // this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cattleDrive/ExternalForm.vue